import { api } from '../../client';

export interface PaymentMadeDto {
  id: string;
  vendor_id: string;
  vendor_name: string;
  bill_id: string | null;
  bill_number: string | null;
  amount: number;
  payment_date: string;
  payment_method: string;
  reference: string;
  notes: string;
  created_at?: string;
}

export const purchasesPaymentsMadeApi = {
  async list(params?: {
    vendor_id?: string;
    from_date?: string;
    to_date?: string;
  }): Promise<{ data?: PaymentMadeDto[]; message?: string }> {
    const sp = new URLSearchParams();
    if (params?.vendor_id) sp.set('vendor_id', params.vendor_id);
    if (params?.from_date) sp.set('from_date', params.from_date);
    if (params?.to_date) sp.set('to_date', params.to_date);
    const q = sp.toString() ? `?${sp.toString()}` : '';
    return api.get(`/purchases/payments-made${q}`) as Promise<{ data?: PaymentMadeDto[] }>;
  },

  async get(id: string): Promise<{ data?: PaymentMadeDto; message?: string }> {
    return api.get(`/purchases/payments-made/${id}`) as Promise<{ data?: PaymentMadeDto }>;
  },

  async create(data: {
    vendor_id: string;
    bill_id?: string;
    amount: number;
    payment_date: string;
    payment_method?: string;
    reference?: string;
    notes?: string;
  }): Promise<{ data?: PaymentMadeDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/purchases/payments-made', data) as Promise<{
      data?: PaymentMadeDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: { reference?: string; notes?: string }
  ): Promise<{ data?: PaymentMadeDto; message?: string }> {
    return api.put(`/purchases/payments-made/${id}`, data) as Promise<{
      data?: PaymentMadeDto;
      message?: string;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/purchases/payments-made/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
